import React, { useCallback, useContext } from 'react'
import { useChat } from 'react-live-chat-loader'
import { StepWizardChildProps } from 'react-step-wizard'
import { useTranslation } from '../../../../i18n'

import XRow from '../../../components/XRow'
import XText from '../../../components/XText'

import HelpFAQIcon from '@svgs/HelpFAQ.svg'
import HelpEmailIcon from '@svgs/HelpEmail.svg'
import HelpChatIcon from '@svgs/HelpChat.svg'
import HelpContactUs from '@svgs/HelpContactUs.svg'

import styles from './style.module.scss'
import XColors from '../../../styles/colors'
import { XTEXT_SIZE, XTEXT_TYPE } from '../../../styles/constants'
import { useRouter } from 'next/router'
import { NAMED_HELP_WIZARD_STEPS } from '../../../constants/wizards'
import ConditionalRender from '../../../../utils/conditionalRender'
import { OrganizationContext } from '../../../context/organization'

interface Props {}

const HelpSelector: React.FC<Props> = (props: Props & StepWizardChildProps) => {
    const { t } = useTranslation()
    const router = useRouter()
    const organizationContext = useContext(OrganizationContext)
    const [state, loadChat] = useChat()
    const showMessenger = useCallback(() => {
        if (state === 'open') {
            loadChat({ open: false })
        } else {
            loadChat({ open: true })
        }
    }, [loadChat, state])

    return (
        <div id="helpContainer" className={styles.helpSelector}>
            <XText size={XTEXT_SIZE.EXTRA_LARGE} type={XTEXT_TYPE.TEXT} color={XColors.midGray}>
                {t('help_center')}
            </XText>
            <XRow
                headerText={t('faq')}
                normalText={t('faq_description')}
                customIcon={HelpFAQIcon}
                onClick={() => {
                    router.push(`/v2/${router.query['program-name']}/help/faq`)
                    props.goToStep(NAMED_HELP_WIZARD_STEPS.HELP_FAQ)
                }}
                ga4_key={t('faq', { lng: 'en' })}
            />
            <XRow
                headerText={t('help_email_title')}
                normalText={t('help_email_description')}
                customIcon={HelpEmailIcon}
                onClick={() => {
                    router.push(`/v2/${router.query['program-name']}/help/email`)
                    props.goToStep(NAMED_HELP_WIZARD_STEPS.HELP_EMAIL)
                }}
                ga4_key={t('help_email_title', { lng: 'en' })}
            />

            <XRow
                headerText={t('live_chat')}
                normalText={t('live_chat_description')}
                customIcon={HelpChatIcon}
                onClick={showMessenger}
                ga4_key={t('live_chat', { lng: 'en' })}
            />

            <ConditionalRender if={organizationContext.program.urlFragment.indexOf('expansion') === -1}>
                <XRow
                    headerText={t('contact_us')}
                    normalText={t('contact_us_description')}
                    customIcon={HelpContactUs}
                    onClick={() => {
                        router.push(`/v2/${router.query['program-name']}/help/contact`)
                        props.goToStep(NAMED_HELP_WIZARD_STEPS.HELP_CONTACT_US)
                    }}
                    ga4_key={t('contact_us', { lng: 'en' })}
                />
            </ConditionalRender>
        </div>
    )
}

export default HelpSelector
